import { Pipe, PipeTransform } from '@angular/core';
import { TaskPriority } from '@shared/models/tasks';

@Pipe({
  name: 'taskUrgency',
})
export class TaskUrgencyPipe implements PipeTransform {
  transform(priority: string): TaskPriority | undefined {
    switch (priority) {
      case '!': return 'Low';
      case '!!': return 'Medium';
      case '!!!': return 'High';
      default: return;
    }
  }
}